import { usePlaylist, usePlaylistRemainingItemsAndProgress } from '../../savedItems';
import { usePlaylistIdFromSearch } from '../hooks';
import intersectionWith from 'hs-lodash/intersectionWith';
import { useMemo } from 'react';
import ContentViewport from '../../../components/ContentViewport';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import UIIllustration from 'UIComponents/image/UIIllustration';
import styled, { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import H3 from 'UIComponents/elements/headings/H3';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import { RouterLink } from '../../../components/AcademyLinks';
import { getListingUrl } from '../../../utils/RoutingUtils';
import UIFlex from 'UIComponents/layout/UIFlex';
import { LearningContentContainer } from '../../learningContent';
import { useHasGate } from '../../accounts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'exam-finished-screen';
const StyledUIIllustration = styled(UIIllustration).withConfig({
  displayName: "PlaylistIncompleteItems__StyledUIIllustration",
  componentId: "sc-1viq46s-0"
})(["margin-right:50px;margin-left:50px;", ""], mediaQuery('tablet', css(["display:none;"])));
const ContentLink = ({
  playlistItem: {
    itemId,
    language,
    type,
    name
  }
}) => {
  const playlistId = usePlaylistIdFromSearch();
  return /*#__PURE__*/_jsx(RouterLink, {
    to: getListingUrl({
      type,
      id: itemId,
      isStarted: true,
      language,
      playlistId: playlistId || undefined,
      appearsIn: 'playlist'
    }),
    children: name
  }, `${itemId}${type}${name}`);
};
export const PlaylistIncompleteItems = () => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    remainingProgressItems
  } = usePlaylistRemainingItemsAndProgress(playlistId);
  const {
    playlist
  } = usePlaylist(playlistId);
  const hasShortsGate = useHasGate('Academy:ShortFormContent');
  const incompleteItems = useMemo(() => {
    if (!remainingProgressItems || !playlist) return [];
    return intersectionWith(playlist.items, remainingProgressItems, (playlistItem, item) => {
      return item.itemId === playlistItem.itemId && item.type === playlistItem.type;
    });
  }, [playlist, remainingProgressItems]);
  return /*#__PURE__*/_jsxs(LearningContentContainer, {
    children: [/*#__PURE__*/_jsx(ContentViewport, {
      wrapperClassName: `${BASE_CLASS_NAME}__content-viewport`,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "center",
        children: [/*#__PURE__*/_jsx(StyledUIIllustration, {
          name: "announcement"
        }), playlist && /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(H3, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.playlistContent.incompletePlaylistContent.incompleteTitle",
              options: {
                playlistTitle: playlist.name
              }
            })
          }), incompleteItems.length > 0 && /*#__PURE__*/_jsx(UIList, {
            children: incompleteItems.filter(currentItem => hasShortsGate || currentItem.type !== 'SHORT_FORM_CONTENT').map(item => /*#__PURE__*/_jsx(ContentLink, {
              playlistItem: item
            }, `${item.itemId}${item.type}${item.name}`))
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      className: `${BASE_CLASS_NAME}__content-control`
    })]
  });
};